
export const sizeUrlImage = (url: string, width: number = 400, height: number = 400) => {
  return `${url}/width=${width},height=${height}/`
}

export const bigImage = (url: string) => sizeUrlImage(url, 1024, 1024);

export const mediumImage = (url: string) => sizeUrlImage(url, 800, 800);

export const smallImage = (url: string) => sizeUrlImage(url, 400, 400);